import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BlockUIModule } from 'primeng/blockui';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TreeTableModule } from 'primeng/treetable';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ExceptionManager } from './components/core/_infrastructure/classes/handlers/exceptionManager';
import {
    ArrayFromNumberPipe,
    IconoCheckEnvioPipe,
    IconoDocumentoTracesPipe,
    IconoDocumentoExTracesPipe,
    IconoEstadoSolicitudPipe,
    IconoTipoSolicitudPipe,
    IconoEstadoChedPPPipe,
    IconoEstadoSolicitudExPipe,
    IconoTipoSolicitudExPipe,
    IconoPreduaSolicitudPipe,
    IconoEstadoCertificadoFitoEx,
    IconoTipoSolicitudAtestPipe,
    IconoSolicitudAsignadaPipe,
    PreduaPipe,
    SiNoPipe,
    TipoClonacionPipe,
    TruncatePipe,
    IconoEstadoSolicitudAtestPipe,
    IconoCopiaCertificadoExPipe,
    IconoEstadoSolicitudCpePipe,
    IconoEstadoPvPipe,
    IconoResultadoEnvioMuestraLaboratorioPipe,
    IconoTwTcSubTipoSolicitudExPipe,
    IconoProdsEmbsRpPipe,
    IconoProdsEmbsRpAceptadoPipe,
    MonthNumberToStringPipe,
    MonthStringNumberToStringPipe,
    MonthStringToNumberPipe,
    MonthStringToStringNumberPipe,
} from './components/core/_infrastructure/classes/pipes';
import { NotificationService } from './components/core/_infrastructure/classes/services/notification.service';
import { TogglerService } from './components/core/_infrastructure/classes/services/toggler.service';
import { IconoEstadoSolicitudCamPipe } from './components/core/_infrastructure/classes/pipes/icono-estado-solicitud-cam.pipe';
import { IconoEstadoUnidadInspeccionPipe } from './components/core/_infrastructure/classes/pipes/icono-estado-unidad-inspeccion.pipe';

@NgModule({
    imports: [
        CommonModule,
        TableModule,
        ConfirmDialogModule,
        CalendarModule,
        RadioButtonModule,
        DialogModule,
        FieldsetModule,
        ToggleButtonModule,
        ProgressSpinnerModule,
        BlockUIModule,
        MultiSelectModule,
        CheckboxModule,
        TriStateCheckboxModule,
        NgbModule,
        TreeTableModule,
        FormsModule,
        ReactiveFormsModule,
        BsDropdownModule.forRoot(),
        NgSelectModule,
        SelectButtonModule,
        ListboxModule,
    ],
    declarations: [
        ArrayFromNumberPipe,
        SiNoPipe,
        TipoClonacionPipe,
        PreduaPipe,
        IconoEstadoSolicitudPipe,
        IconoTipoSolicitudPipe,
        IconoEstadoChedPPPipe,
        IconoEstadoSolicitudExPipe,
        IconoTipoSolicitudExPipe,
        IconoEstadoSolicitudCpePipe,
        IconoCopiaCertificadoExPipe,
        IconoEstadoCertificadoFitoEx,
        IconoEstadoSolicitudAtestPipe,
        IconoTipoSolicitudAtestPipe,
        IconoPreduaSolicitudPipe,
        IconoEstadoCertificadoFitoEx,
        IconoCheckEnvioPipe,
        IconoSolicitudAsignadaPipe,
        TruncatePipe,
        IconoDocumentoTracesPipe,
        IconoDocumentoExTracesPipe,
        IconoEstadoSolicitudCamPipe,
        IconoEstadoUnidadInspeccionPipe,
        IconoEstadoPvPipe,
        IconoResultadoEnvioMuestraLaboratorioPipe,
        IconoTwTcSubTipoSolicitudExPipe,
        IconoProdsEmbsRpPipe,
        IconoProdsEmbsRpAceptadoPipe,
        MonthNumberToStringPipe,
        MonthStringNumberToStringPipe,
        MonthStringToNumberPipe,
        MonthStringToStringNumberPipe,
    ],
    providers: [NotificationService, TogglerService, ExceptionManager],
    exports: [
        ArrayFromNumberPipe,
        SiNoPipe,
        TipoClonacionPipe,
        PreduaPipe,
        IconoEstadoSolicitudPipe,
        IconoTipoSolicitudPipe,
        IconoEstadoChedPPPipe,
        IconoEstadoSolicitudExPipe,
        IconoTipoSolicitudExPipe,
        IconoCopiaCertificadoExPipe,
        IconoEstadoSolicitudAtestPipe,
        IconoTipoSolicitudAtestPipe,
        IconoEstadoSolicitudCpePipe,
        IconoEstadoCertificadoFitoEx,
        IconoSolicitudAsignadaPipe,
        IconoPreduaSolicitudPipe,
        IconoCheckEnvioPipe,
        IconoDocumentoTracesPipe,
        IconoDocumentoExTracesPipe,
        IconoEstadoSolicitudCamPipe,
        IconoEstadoUnidadInspeccionPipe,
        IconoEstadoPvPipe,
        IconoResultadoEnvioMuestraLaboratorioPipe,
        IconoTwTcSubTipoSolicitudExPipe,
        IconoProdsEmbsRpPipe,
        IconoProdsEmbsRpAceptadoPipe,
        MonthNumberToStringPipe,
        MonthStringNumberToStringPipe,
        MonthStringToNumberPipe,
        MonthStringToStringNumberPipe,
        TableModule,
        DialogModule,
        FieldsetModule,
        CalendarModule,
        RadioButtonModule,
        ConfirmDialogModule,
        NgbModule,
        ToggleButtonModule,
        ProgressSpinnerModule,
        BlockUIModule,
        MultiSelectModule,
        TreeTableModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        TriStateCheckboxModule,
        CheckboxModule,
        TruncatePipe,
        SelectButtonModule,
        ListboxModule,
    ],
})
export class AppModuleGlobalShared {}
